module.exports = __webpack_public_path__ + "img/2.860091de.svg";